<template>
  <div>
    <div style="margin-top: 10px; text-align: left;">
    <h2>Item List</h2>
    <div>
      <el-table
        :data="$store.state.productionItemIssue.props.item_list"
        style="width: 100%">
        
        <el-table-column 
        prop="inventory_item_id"
        label="SKU#" width="300">
            <template slot-scope="scope"> 
                <div 
                    v-if="scope.row.item_edit === 0" 
                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                    <el-select 
                        @change="loadProductDetails(scope.row.key)"
                        :disabled="$store.getters.getProductionItemIssueDataProps.status > 0"
                        placeholder="search or scan"
                        :id="'inventory_item_id_'+scope.row.key"
                        remote
                        :remote-method="searchSKUCode"
                        size="small"
                        default-first-option
                        :loading="getLoading"
                        v-model="scope.row.inventory_item_id" filterable style="text-align: left; width: 80%;">
                        <el-option
                            v-for="(data, index) in $store.getters.getInventoryMasterAutocompleteList"
                            :key="index"
                            :label="data.sku_code"
                            :value="data.id">
                            <span style="float: left" v-html="data.sku_code+' ('+data.article_name+')'"></span>
                            <span style="float: right;" v-if="data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0"><b :style="'color: '+(data.closing_stock<0 ? 'red' : 'green')">{{data.closing_stock}} {{data.unit_name}}</b></span>
                        </el-option>
                    </el-select>
                    <a @click="openQRScanner(scope.row.key)" style="cursor: pointer;"><img src="https://etacdn.b-cdn.net/qr-scan.png" width="25px" style="top: 3px; position: relative;"/></a>
                    
                    <el-tooltip class="item" effect="dark" content="Add new inventory item">
                        <a 
                            style="cursor: pointer; font-size: 16px; top: 5px; left: 0px; position: relative;"
                            @click="checkIfInventoryAddAccessGiven(scope.row.key)">
                            <i class="el-icon-circle-plus"></i>
                        </a>                    
                    </el-tooltip>
                </div>
                
                <div v-else>
                    {{scope.row.item_detail.sku_code}}, {{scope.row.item_detail.article_name}}  
                    
                        <a @click="disableEdit(scope.row.key)" style="cursor: pointer; font-size: 16px; margin-left: 10px; ">
                            <sup><i class="el-icon-error"></i></sup>       
                        </a>
                               
                </div>
            </template>
        </el-table-column>
        
        <el-table-column
        prop="qty"
        :label="'QTY'" 
        align="center" width="110">
            <template slot-scope="scope">
                <el-input @focus="$event.target.select()"
                    :disabled="$store.getters.getProductionItemIssueDataProps.status > 0"
                    :id="'qty_'+scope.row.key"
                    v-model="scope.row.qty"
                    size="small"
                    type="number"
                    @keyup.enter.native="addRow(scope.row.key)"
                    style="width: 100px; text-align: center;">
                </el-input>
            </template>
        </el-table-column>

        <el-table-column
        prop="notes"
        :label="'Remarks'">
            <template slot-scope="scope">
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="scope.row.notes">
                </el-input>
            </template>
        </el-table-column>

        <el-table-column
            fixed="right"
            label=""
            width="120">
            <template slot-scope="scope">
                <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                    <el-tooltip class="item" effect="dark" content="Add">
                        <a @click="addRow(scope.row.key)" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                        </a>
                    </el-tooltip>
                    
                    <el-tooltip class="item" effect="dark" content="Delete">
                        <el-popconfirm
                            @confirm="$store.commit('removeProductionItemIssueItemListRow', scope.row.key)"
                            title="Are you sure to delete this?"
                            >
                            <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                <i class="el-icon-delete"></i>
                            </a>
                            
                        </el-popconfirm>
                    </el-tooltip>
                    
                </div>                                      
            </template>
        </el-table-column>
        </el-table>
    </div>
    </div>
    <el-dialog
        v-if="show_qr_window"
        width="70%"
        :visible.sync="show_qr_window"
        append-to-body>
        <qrcode-stream @decode="onDecode" @closed="show_qr_window = false"></qrcode-stream>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data() {
        return {
            showInventoryMaster: false,
            key: -1,
            show_qr_window: false
        }
    },
    computed: {
        getKey() {
            return this.key
        },
        getLoading() {
            return this.$store.state.inventoryMaster.loading
        }
    },
    methods: {
        openQRScanner(key) {
            this.key = key
            this.show_qr_window = true
        },
        onDecode($event) {
            this.searchSKUCode($event)
            this.show_qr_window = false
            this.changeFocus('inventory_item_id_'+this.key)
        },
        loadProductDetails(key) {
            let skuId = this.$store.state.productionItemIssue.props.item_list[key].inventory_item_id
            if(skuId !== null) {
                let itemIndex = this.$store.getters.getInventoryMasterAutocompleteList.findIndex((t) => t.id === parseInt(skuId))
                if(itemIndex>=0) {

                    let itemDetail = this.$store.getters.getInventoryMasterAutocompleteList[itemIndex]
                    
                    this.$store.state.productionItemIssue.props.item_list[key].item_detail = 
                        {id: itemDetail.id, sku_code: itemDetail.sku_code, article_name: itemDetail.article_name, unit_name: itemDetail.unit_name}

                    this.$store.state.productionItemIssue.props.item_list[key].item_edit = 1
                    setTimeout(() => {
                        document.getElementById('qty_'+key).focus()    
                    }, 200);                        
                }                
            }
        },
        searchSKUCode(query) {
            this.$store.dispatch('fetchInventoryMasterAutocompleteList', 
                {query: query, search_raw_material_only: true, search_column: ['sku_code', 'article_name'], store_id: this.$store.state.productionItemIssue.props.store_id})
        },
        addRow(key) {
            let itemId = this.$store.state.productionItemIssue.props.item_list[key].inventory_item_id
            if(itemId === null || itemId === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select a SKU code', type: 'Error'})    
                return
            }
            this.$store.state.productionItemIssue.props.item_list[key].item_edit = false
            this.$store.commit('addNewProductionItemIssueItemListRow')
        },
        addNewArticle(key) {
            this.$store.commit('resetInventoryMasterData')
            this.key = key
            this.showInventoryMaster = true
        },
        closeInventoryWindow($event) {
            this.showInventoryMaster = false
            if($event.id>0) {
                this.$store.state.productionItemIssue.props.item_list[this.getKey].item_detail = $event
                this.$store.state.productionItemIssue.props.item_list[this.getKey].inventory_item_id = $event.id
                this.$store.state.productionItemIssue.props.item_list[this.getKey].item_edit = 1
                setTimeout(() => {
                    this.loadProductDetails()
                }, 300);
            }            
        },
        disableEdit(key) {
            this.$store.state.productionItemIssue.props.item_list[key].item_edit = 0
        }, 
        checkIfInventoryAddAccessGiven(key) {
            
            let routeIndex = this.$store.getters.getAccessibleMenu.findIndex((t) => t.route_path == '/inventoryproducts')
            let routeAccessInfo = this.$store.getters.getAccessibleMenu[routeIndex]
            
            if(routeAccessInfo.can_add) {
              this.addNewArticle(key)
            } else {
                this.$store.commit('displayMessageAlert', {message: 'You do not have access to inventory master form', type: 'Error'})    
                return
            }
            
        }

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ProductionItemIssue/ItemList.vue